<!-- eslint-disable -->
<template lang="pug">
    .olympiad-waiting
        transition(
            name="fade",
            enterActiveClass="fade--enter-active",
            enterClass="fade--enter",
            enterToClass="fade--enter-to",
            leaveActiveClass="fade--leave-active",
            leaveClass="fade--leave",
            leaveToClass="fade--leave-to"
        )
            countdown(
                v-if="showCountdown",
                :levels="olympiad.levels"
                @countFinished="$router.push({name: 'olympiads:start', params: {id: level.id}})"
            )
        cs-loader(v-if="isLoading")
        .olympiad-waiting__box(v-else)
            .olympiad-waiting__block
                olympiad-box
                    template(slot="top")
                        olympiad-preview(
                            :olympiad="olympiad",
                            :withTime="true",
                            :showStatus="true"
                        )
                        .olympiad-waiting__buttons-container
                            cs-button.olympiad-waiting__button(
                                v-if="user.type !== 'student'"
                                pattern="primary-outline",
                                @click="showUsers"
                            )
                                span(v-text="participantsCountText")
                            cs-button.olympiad-waiting__button(v-if="isTrainerAvailable", @click="startTrainerGames")
                                | {{ $i18n.t('olympiads.olympiads_showPage_startTrainer') }}
                            cs-button.olympiad-waiting__button(
                                v-if="isShowEditButton",
                                pattern="primary-outline",
                                @click="editOlympiad"
                            )
                                | {{ $i18n.t('school.school_edit_button') }}
                            cs-button.olympiad-waiting__button(
                                v-if="user.isSuperadmin",
                                pattern="primary-outline",
                                @click="copyOlympiad"
                            )
                                | {{ $i18n.t('homework.homework_create_copy') }}
                    .olympiad-waiting__box-bottom(
                        v-if="(user.type === 'student' || user.type === 'olympiads-student') && isToday && level && !level.isCompleted",
                        slot="bottom"
                    )
                        .olympiad-waiting__timer(v-if="level.secondsToStart > 0")
                            span.olympiad-waiting__timer-title {{ $i18n.t('olympiads.olympiads_showPage_beforeStart') }}:
                            p.olympiad-waiting__timer-time(v-text="timeToStart")
                        cs-button.olympiad-waiting__button(v-else, @click="startGames", id="start-button")
                            | {{ $i18n.t('olympiads.olympiads_showPage_start') }}
            .olympiad-waiting__buttons-container
                router-link(:to=`{name: 'olympiads:index'}`)
                    cs-button.olympiad-waiting__button(pattern="primary-inverse") {{ $i18n.t('olympiads.olympiads_showPage_toOlympiadsList') }}
                router-link(:to=`{name: 'trainer:main'}`)
                    cs-button.olympiad-waiting__button(pattern="primary-dark-outline") {{ $i18n.t('common.common_navigation_exit') }}
</template>

<script>
    /*eslint-disable*/
    import OlympiadBox from './Box.vue'
    import OlympiadPreview from './Preview.vue'
    import OlympiadApi from '../../api/olympiad'
    import {mapState} from 'vuex';
    import moment from "moment";
    import Countdown from './modals/Countdown.vue'

    const {noun} = require('plural-ru');

    const timezone = 'Europe/Moscow';

    export default {
        props: {
            id: [Number, String]
        },
        data() {
            return {
                isLoading: true,
                olympiad: null,
                level: null,
                timer: null,
                isToday: null,
                showCountdown: false,
                startSoundPlayed: false,
                isSoundLoaded: false,
                olympiadCourseType: 'mental-arithmetic',
            };
        },
        computed: {
            ...mapState({
                user: state => state.auth.user
            }),
            isTrainerAvailable () {
                if (this.level && this.level.authRegisteredUser[0] && this.level.isTrainerAvailable) {
                    let today = moment().format('YYYY-MM-DD');
                    let formattedStopDate = moment(this.level.stopTrainerDate).format('YYYY-MM-DD');
                    return moment(today).isSameOrBefore(formattedStopDate);
                }
                return false;
            },
            momentDuration() {
                return this.level ? moment.duration(this.level.secondsToStart, 'seconds') : null;
            },
            showResult () {
                return moment.tz('Europe/Moscow').isAfter(moment.tz(this.olympiad.date, timezone), 'day');
            },
            timeToStart() {
                let hours = this.momentDuration.hours();
                let minutes = this.momentDuration.minutes();
                let seconds = this.momentDuration.seconds();
                let resultString = '';
                if (hours) {
                    resultString += hours + ' ' + this.$i18n.tc('olympiads.olympiads_timeDeclination_hours', hours) + ' ';
                }
                if (minutes) {
                    resultString += minutes + ' ' + this.$i18n.tc('olympiads.olympiads_timeDeclination_minutes', minutes) + ' ';
                }
                resultString += seconds + ' ' + this.$i18n.tc('olympiads.olympiads_timeDeclination_seconds', seconds);
                return resultString;
            },
            participantsCountText() {
                return this.olympiad.participantsCount + ' '
                        + this.$i18n.tc('olympiads.olympiads_showPage_participantDeclination', this.olympiad.participantsCount);
            },
            isShowEditButton () {
                return this.user.isSuperadmin || this.user.isManagerOrSupport;
            }
        },
        mounted () {
            this.fetchData();
        },
        methods: {
            fetchData() {
                this.isLoading = true;
                return OlympiadApi.show(this.id)
                .then((olympiad) => {
                    this.olympiad = olympiad;
                    this.isToday = moment.tz('Europe/Moscow').isSame(moment.tz(this.olympiad.date, timezone), 'day');
                    if (this.user.type === 'student' || this.user.type === 'olympiads-student') {
                        this.olympiad.levels.forEach(level => {
                            if (level.authRegisteredUser[0]) {
                                this.level = level;
                                this.olympiadCourseType = level.stages[0].games[0].courseType;
                                this.timer = setInterval(() => {
                                    --this.level.secondsToStart;
                                    !this.level.secondsToStart && clearInterval(this.timer);
                                }, 1000);
                            }
                        });
                        if (this.olympiad.status === 'archived') {
                            this.$router.push({ name: 'olympiads:results', params: { id: this.id } });
                        } else if (this.user.type === 'student' && !this.level && this.olympiad.isRegistrationAllowed) {
                            this.$router.push({name: 'olympiads:register', params: {id: this.id}});
                        }
                    }
                    this.isLoading = false;
                    if (this.level) {
                        this.loadSounds()
                        .then(() => {
                            this.isSoundLoaded = true;
                        });
                        this.level.isRealTime && this.listenStartEvent();
                    }
                })
                .catch(err => {
                    if (err.data && err.data.status_code === 403) {
                        this.$toasted.error(this.$root.$t('errors.olympiad_no_access'));
                        this.$router.push({ name: 'dashboard'});
                    } else {
                        this.$toasted.error(this.$root.$t('errors.getting_olympiadList'));
                    }
                })
            },
            listenStartEvent () {
                this.$echo.private(`stage.${this.user.id}`).listen('StartStage', data => {
                    if (data.stage.level.id === this.level.id) {
                        this.startGames();
                    }
                });
            },
            editOlympiad() {
                this.$router.push({name: 'olympiads:edit', params: {olympiadId: this.id}})
            },
			copyOlympiad() {
				this.$router.push({name: 'olympiads:create', params: {olympiadId: this.id}})
			},
            showUsers() {
                this.$router.push({name: 'olympiads:students-list', params: {id: this.id}})
            },
            loadSounds () {
                return new Promise(resolve => {
                    let sound = OlympiadApi.getStartSound(this.olympiadCourseType);
                    this.$createjs.Sound.removeAllSounds();
                    this.$createjs.Sound.removeAllEventListeners();
                    this.$createjs.Sound.addEventListener('fileload', resolve);
                    this.$createjs.Sound.alternateExtensions = ["mp3"];
                    this.$createjs.Sound.registerSound(sound);
                });
            },
            startGames () {
                if (!this.level.authRegisteredUser[0].pivot.startTime) {
                    this.openCountdown();
                } else {
                    this.$router.push({name: 'olympiads:start', params: {id: this.level.id}});
                }
            },
            startTrainerGames () {
                this.$router.push({name: 'olympiads:start', params: {id: this.level.id, isTrainer: true}});
            },
            openCountdown () {
                this.showCountdown = true;
            }
        },
        beforeRouteLeave(to, from, next) {
            if (!to.name.includes('olympiads')) {
                this.$createjs.Sound.removeAllSounds();
                this.$createjs.Sound.removeAllEventListeners();
            }
            if (this.timer) {
                clearInterval(this.timer);
            }
            next();
        },
        components: {
            OlympiadBox,
            OlympiadPreview,
            Countdown
        }
    }
</script>

<style lang="scss" scoped>
    .olympiad-waiting {
        margin: 0 auto;
        @include media($lg) {
            width: 70%;
        }
    }

    .olympiad-waiting__block {
        @include stack-space($space-base);
    }

    .olympiad-waiting__buttons-container {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        @include media($sm) {
            flex-direction: row;
        }
    }

    .olympiad-waiting__box-bottom {
        text-align: center;
    }

    .olympiad-waiting__button {
        padding: 10px 15px !important;
        margin: 10px;
        width: fit-content;
        @include media($sm) {
            padding: 15px 30px !important;
            width: auto;
        }
    }

    .olympiad-waiting__turtle {
        position: fixed;
        max-height: 30vh;
        max-width: 10vw;
        right: 2%;
        bottom: 5%;
    }

    .fade--enter-active, .fade--leave-active {
        transition: opacity .6s;
    }

    .fade--enter, .fade--leave-to {
        opacity: 0;
    }

    .fade--enter-to, .fade--leave {
        opacity: 1;
    }
</style>
